module.exports = __webpack_public_path__ + "img/tv-room.842ab804.jpeg";